import { styled } from 'styled-components';

import FormRow from 'components/FormRow';
import Input from 'components/ui/Input';
import Button from 'components/ui/Button';
import usePassword from './hooks/usePassword';
import Section from 'pages/Account/components/Section';

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const ButtonView = styled.div`
  margin-top: 10px;
`;

const PasswordSection = () => {
  const {
    useFormReturn: {
      formState: { errors, isSubmitting },
      register,
      handleSubmit,
    },
    isDisabled,
    isUpdateMode,
    onValid,
    onUpdateModeButtonClick,
  } = usePassword();

  return (
    <Section maxWidth={400} title="비밀번호 변경">
      {isUpdateMode ? (
        <Form onSubmit={handleSubmit(onValid)}>
          <FormRow label="현재 비밀번호" error={errors?.password?.message}>
            <Input {...register('password')} type="password" />
          </FormRow>
          <FormRow label="새 비밀번호" error={errors?.newPassword?.message}>
            <Input {...register('newPassword')} type="password" />
          </FormRow>
          <FormRow label="새 비밀번호 확인" error={errors?.passwordConfirm?.message}>
            <Input {...register('passwordConfirm')} type="password" />
          </FormRow>
          <ButtonView>
            <Button disabled={isDisabled || isSubmitting}>비밀번호 변경</Button>
          </ButtonView>
        </Form>
      ) : (
        <Button onClick={onUpdateModeButtonClick}>비밀번호 변경</Button>
      )}
    </Section>
  );
};

export default PasswordSection;
